module.exports = __webpack_public_path__ + "img/play-outline.184ef4d8.svg";